export const common = {
  // Navigation
  "nav.home": "Home",
  "nav.features": "Features",
  "nav.benefits": "Benefits",
  "nav.contact": "Contact",
  "nav.language": "Language",
  
  // Hero Section
  "hero.title": "GPAX: Platform that allows digital auditing",
  "hero.subtitle": "Write your annual plan, carry out audits, supervise work, manage reports. Provide your audit and administrative teams with a tool that supports follow up on report findings.",
  "hero.cta": "Get Started",
  "hero.demo": "View Demo",
  
  // Features
  "features.centralized": "Centralized",
  "features.secure": "Secure",
  "features.realtime": "In real time",
  
  // Modules
  "modules.title": "GPAX Audit modules",
  "modules.risk": "Risk",
  "modules.planning": "Planning",
  "modules.execution": "Execution",
  "modules.communication": "Communication",
  
  // Risk Module
  "risk.title": "GPAX Audit provides a tool that allows you to manage your risks, measure the effectiveness of controls and ensure that control activities are carried out.",
  "risk.feature1": "Prioritize activities based on risk assessment of the Auditable Universe.",
  "risk.feature2": "Risk assessment of the processes executed by the company or organization.",
  "risk.feature3": "Management and evaluation of operational risk through the entry of the SARO risk matrix, detailing risk factors, events and control activities.",
  "risk.feature4": "Customization of scales, weights, values, etc., fully configurable.",
  
  // Planning Module
  "planning.title": "GPAX Audit allows you to define the processes, activities, documents and details that will be evaluated during the annual plan, based on standards, specifications, normativity, laws or regulations.",
  "planning.feature1": "Administration of institutional strategic plan.",
  "planning.feature2": "Preparation of annual plan based on risk, prioritizing the evaluations according to their risk.",
  "planning.feature3": "Alignment of the strategic objectives with objectives of annual audit plan.",
  "planning.feature4": "Administration and control of allocation of human resources, budgets and real financial resources.",
  "planning.feature5": "Control of the start and end date of each audit, compared to the actual start and end date.",
  
  // Execution Module
  "execution.title": "GPAX Audit allows executing procedures, reviewing and analyzing evidence, generating the digital file of each audit.",
  "execution.feature1": "Administration and control of staff assignments in real time.",
  "execution.feature2": "Supervision and authorization of the planning and work program of each assignment in real time.",
  "execution.feature3": "Digitization of working papers of each procedure carried out by the auditors.",
  "execution.feature4": "Real-time supervision for effective work execution, complying with quality assurance and continuous improvement programs.",
  "execution.feature5": "Supervision and control of assigned resources, both financial and the real time invested in the procedures of each job.",
  "execution.feature6": "Alarms, notifications, progress indicators and comparative statistics.",
  
  // Communication Module
  "communication.title": "GPAX Audit includes a reciprocal communication channel that allows both the auditor and auditees to manage their findings and action plans.",
  "communication.feature1": "Administration and control of the reports generated for each job.",
  "communication.feature2": "Control in conjunction with the administration for the review and monitoring of recommendations and compliance with action plans.",
  "communication.feature3": "Automated control through alarms and notifications of expiry of findings and action plans.",
  "communication.feature4": "Real-time recording of evidence of satisfactory compliance with action plans.",
  "communication.feature5": "Control through Kanban of findings, pending and/or expired action plans.",
  
  // Benefits
  "benefits.title": "Key Benefits",
  "benefits.reduce": "Reduce 50%",
  "benefits.reduce.desc": "Reduces documentation time by up to 50%, generating valuable information.",
  "benefits.cost": "Up to 90%",
  "benefits.cost.desc": "Up to 90% reduction in operating costs.",
  "benefits.affordable": "Affordable cost",
  "benefits.affordable.desc": "Affordable cost, great flexibility and fast implementation.",
  "benefits.improves": "Improves up to 40%",
  "benefits.improves.desc": "Improves up to 40% the productivity and execution of the projects.",
  
  // Other Features
  "other.title": "Other features",
  "other.feature1": "Knowledge base: Administration of human capital and quality standards.",
  "other.feature2": "Alerts, dashboards, indicators and reports.",
  "other.feature3": "Multilanguage.",
  "other.feature4": "Mail system to send notifications.",
  "other.feature5": "Internet banking type security.",
  "other.feature6": "Authentication with Microsoft accounts.",
  
  // Advantages
  "advantages.title": "Advantages",
  "advantages.subtitle": "Guaranteed access to key indicators in real time.",
  "advantages.feature1": "Management of the strategic and operational plan.",
  "advantages.feature2": "Execution of projects using Gantt.",
  "advantages.feature3": "Generation of alerts and indicators.",
  "advantages.feature4": "Online chat for team work.",
  "advantages.feature5": "Control of resources and work carried out.",
  "advantages.feature6": "Dashboards.",
  
  // Success Stories
  "success.title": "Success stories",
  "success.auditing": "Auditing organizations",
  "success.auditing.desc": "200 coordinated auditors, carrying out their work online, with proactive supervision and obtaining results in real time.",
  "success.financial": "Financial entity",
  "success.financial.desc": "Fully managed audit, allowing auditees also to have a tool to monitor their pending issues.",
  "success.municipality": "Municipality",
  "success.municipality.desc": "Control of documentation and review flow management, centralized management of complaints and claims.",
  
  // CTA
  "cta.title": "Want to know more about us?",
  "cta.button": "Contact us",
  
  // Footer
  "footer.contact": "Contact",
  "footer.phone": "+506 2447 9912",
  "footer.email": "soluciones@infowarecr.com",
  "footer.talk": "Talk to us",
  "footer.terms": "Terms and Services",
  "footer.privacy": "Privacy",
  "footer.sla": "SLA"
};

export default common;